import { Button, InlineWarning, P } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@driftt/tide-modal'
import React from 'react'

const ExperimentModal = ({
  open,
  onClose,
  onCreateExperiment,
  onDeleteExperiment,
  hasExperiment,
  isExperimentEditorActive,
}) => {
  const handleClick = () => {
    hasExperiment
      ? onDeleteExperiment({ useVariant: !isExperimentEditorActive })
      : onCreateExperiment()
    onClose()
  }

  const title = hasExperiment
    ? 'Are you sure you want to delete this A/B test?'
    : 'Ready to create an A/B test?'

  const body = hasExperiment ? (
    <P>
      Bot flow {isExperimentEditorActive ? 'B' : 'A'} will be removed from this
      playbook.
    </P>
  ) : (
    <>
      <P>
        Once a test is created, this playbook flow will be duplicated. About 50%
        of targeted visitors will see bot flow A, and 50% will see bot flow B.
      </P>
      <InlineWarning
        type="info"
        copy="Your A/B test will be off until manually started"
      />
    </>
  )

  return (
    <Modal open={open} onClose={onClose} size="small">
      <ModalTitle>{title}</ModalTitle>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <Button onClick={handleClick}>
          {hasExperiment ? 'Delete' : 'Create'}
        </Button>
        <Button type="tertiary" onClick={onClose} style={{ marginLeft: 8 }}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ExperimentModal
